import * as React from 'react'

import type { Role } from '@app/domain/iam/user.interface'
import { useAuth } from '@app/state/authenticate/hooks'

import history from './history'

interface Props {
  onFailRedirectTo: string
  role: Role
  children: React.ReactNode
}

export const RequireRole = function ({
  onFailRedirectTo,
  role,
  children,
}: Props) {
  const auth = useAuth()

  React.useEffect(() => {
    if (!auth.hasRole(role)) {
      history.push(onFailRedirectTo)
    }
  }, [auth, onFailRedirectTo, role])

  return <React.Fragment>{children}</React.Fragment>
}
